<script>
import Layout from '@/components/layout/app-layout'
import appConfig from '@/app.config'
import PageHeader from '@/components/layout/page-header'
import moment from 'moment'
import { authComputed } from '@/state/helpers'

import TotalRevenueCard from './shared/total-revenue.card'
import MillingRevenueCard from './shared/milling-revenue.card'
import MillingQuantityCard from './shared/milling-quantity.card'
import TotalOrdersCard from './shared/total-orders.card'
import WeeklyMillingQtyCard from './shared/weekly-milling-qty.card'
import WeeklyMillingAvgCard from './shared/weekly-milling-avg.card'
import MonthlyMillingQtyCard from './shared/monthly-milling-qty.card.vue'
import MonthlyMillingAvgCard from './shared/monthly-milling-avg.card.vue'
import PeriodSalesPerCustomerCard from './shared/period-sales-per-customer.card'
import PeriodSalesPerGroupCard from './shared/period-sales-per-group.card'
import FoamTypeStatsCard from './shared/foam-type-stats.card.vue'

export default {
  name: 'stats.sales',
  page: {
    title: 'Sales Statistics',
    meta: [{ name: 'description', settings_content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,

    TotalRevenueCard,
    TotalOrdersCard,
    MillingRevenueCard,
    MillingQuantityCard,
    WeeklyMillingQtyCard,
    WeeklyMillingAvgCard,
    MonthlyMillingQtyCard,
    MonthlyMillingAvgCard,
    PeriodSalesPerCustomerCard,
    PeriodSalesPerGroupCard,
    FoamTypeStatsCard
  },
  computed: {
    ...authComputed
  },
  watch: {
    startDate: 'onRefresh'
  },
  data () {
    return {
      isLoading: false,
      items: [
        {
          text: 'Statistics'
        },
        {
          text: 'Sales',
          active: true
        }
      ],
      startDate: moment(),
      endDate: moment()
    }
  },
  methods: {
    async onRefresh () {
      this.isLoading = true

      await Promise.all([
        this.$refs['totalRevenue'].onRefresh(),
        this.$refs['totalOrders'].onRefresh(),
        this.$refs['millingRevenue'].onRefresh(),
        this.$refs['millingQty'].onRefresh(),
        this.$refs['monthlyMillingQty'].onRefresh(),
        this.$refs['monthlyMillingAvg'].onRefresh(),
        this.$refs['weeklyMillingQty'].onRefresh(),
        this.$refs['weeklyMillingAvg'].onRefresh(),
        this.$refs['periodCustomerSales'].onRefresh(),
        this.$refs['periodSales'].onRefresh()
      ])

      this.isLoading = false
    }
  },
  async mounted () {}
}
</script>
<template>
  <Layout>
    <PageHeader :items="items">
      <div slot="title" class="d-flex align-items-center">
        <h4 class="mb-0">{{ $t('Sales Statistics') }}</h4>
        <b-btn variant="icon" @click="onRefresh()"
          ><i class="bx bx-sync font-size-18"
        /></b-btn>
      </div>
    </PageHeader>

    <b-row>
      <b-col :md="6" :xl="3">
        <total-revenue-card class="shadow-sm" ref="totalRevenue" />
      </b-col>
      <b-col :md="6" :xl="3">
        <total-orders-card class="shadow-sm" ref="totalOrders" />
      </b-col>
      <b-col :md="6" :xl="3">
        <milling-revenue-card class="shadow-sm" ref="millingRevenue" />
      </b-col>
      <b-col :md="6" :xl="3">
        <milling-quantity-card class="shadow-sm" ref="millingQty" />
      </b-col>
      <b-col :md="6" :xl="3">
        <monthly-milling-qty-card class="shadow-sm" ref="monthlyMillingQty" />
      </b-col>
      <b-col :md="6" :xl="3">
        <monthly-milling-avg-card class="shadow-sm" ref="monthlyMillingAvg" />
      </b-col>
      <b-col :md="6" :xl="3">
        <weekly-milling-qty-card class="shadow-sm" ref="weeklyMillingQty" />
      </b-col>
      <b-col :md="6" :xl="3">
        <weekly-milling-avg-card class="shadow-sm" ref="weeklyMillingAvg" />
      </b-col>
      <b-col :md="12" :xl="6">
        <period-sales-per-customer-card
          class="shadow-sm"
          ref="periodCustomerSales"
        />
      </b-col>
      <b-col :md="12" :xl="6">
        <period-sales-per-group-card class="shadow-sm" ref="periodSales" />
      </b-col>
      <b-col :md="6">
        <foam-type-stats-card
          class="shadow-sm"
          data_field="revenue"
          title="Revenue Per Foam Type"
        />
      </b-col>
      <b-col :md="6">
        <foam-type-stats-card
          class="shadow-sm"
          data_field="quantity"
          title="Quantities Per Foam Type"
        />
      </b-col>
    </b-row>
  </Layout>
</template>
